import React from 'react';
import styled from 'styled-components';

const TextWrapper = ({ children, className }) => {
    const TextWrapper = styled.div`
            max-width: ${props => props.theme.space[23]};
            line-height: ${props => props.theme.space[9]};
            margin-bottom: ${props => props.theme.space[7]};
    `;

    return (
        <TextWrapper className={className}>
            {children}
        </TextWrapper >
    );
};

export default TextWrapper;



// WEBPACK FOOTER //
// ./src/components/styles/TextWrapper.js